import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { numOfDaggers } from '@app/components/pages/checkout/shopping-cart/QuickOrder/utils';

const UnitPriceTableHeader = ({ currency }) => {
  const [t] = useTranslation();

  const taxDisclaimerMessage = useSelector(s => s.orders?.taxDisclaimerMessage);
  const isQuantityMergeEnabled = useSelector(
    s => s?.common?.isQuantityMergeEnabled
  );

  return (
    <>
      <span className="u-color--DarkGray u-fs--14 fw-bold text-univers">
        {t('UNIT_PRICE')}
      </span>
      <span className="u-color--DarkGray u-fs--14 not-bold text-univers">{` (${currency})`}</span>

      {!!taxDisclaimerMessage && (
        <p className="u-fs--12 text-transform-none u-color--DarkGray not-bold text-univers mb-0">
          <>
            {taxDisclaimerMessage}
            {!isQuantityMergeEnabled ? (
              <sup>&dagger;&dagger;</sup>
            ) : (
              <sup>&dagger;</sup>
            )}
          </>
        </p>
      )}
    </>
  );
};

UnitPriceTableHeader.propTypes = {
  currency: PropTypes.string
};

export default UnitPriceTableHeader;
